import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinCityIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C8.134 2 5 5.134 5 9C5 12.966 9.404 18.82 11.226 21.071C11.626 21.565 12.374 21.565 12.774 21.071C14.596 18.82 19 12.966 19 9C19 5.134 15.866 2 12 2ZM15.333 10H15V12.333C15 12.702 14.702 13 14.333 13H13.666C13.298 13 13 12.702 13 12.333V10H11V12.333C11 12.702 10.702 13 10.333 13H9.667C9.298 13 9 12.702 9 12.333V10H8.667C8.298 10 8 9.702 8 9.333C8 9.123 8.099 8.926 8.267 8.8L11.4 6.45C11.756 6.183 12.244 6.183 12.6 6.45L15.733 8.8C15.901 8.926 16 9.123 16 9.333C16 9.702 15.702 10 15.333 10Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinCityIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinCityIcon;
